import {useQuery} from '@tanstack/react-query';
import SmartTestingReportingService, {
    type SmartTestingMetrics,
    type SmartTestCardsResponse,
} from '../services/smartTestingReportingService';

export function useSmartTestingMetrics(
    mldOrgId: number | undefined | null,
    opts?: {startDate?: string; endDate?: string}
) {
    return useQuery<SmartTestingMetrics>({
        queryKey: ['smart-testing-metrics', mldOrgId, opts?.startDate, opts?.endDate],
        queryFn: () =>
            SmartTestingReportingService.getMetrics(mldOrgId as number, {
                startDate: opts?.startDate,
                endDate: opts?.endDate,
            }),
        enabled: typeof mldOrgId === 'number' && mldOrgId > 0,
        staleTime: 60 * 1000,
    });
}

export function useSmartTestingCards(
    mldOrgId: number | undefined | null,
    campaignId: number | undefined | null
) {
    return useQuery<SmartTestCardsResponse>({
        queryKey: ['smart-testing-cards', mldOrgId, campaignId],
        queryFn: () => SmartTestingReportingService.getCards(mldOrgId as number, campaignId as number),
        enabled:
            typeof mldOrgId === 'number' && mldOrgId > 0 && typeof campaignId === 'number' && campaignId > 0,
        staleTime: 60 * 1000,
    });
}
